import { redirect } from '@tanstack/react-router'

import { warmTradingPage } from '@/features/trading-history/lib/tradingLoader'
import type { RouterContext } from '@/routes/layouts/root'

/**
 * The `/market/stock-trading` loader: see `warmTradingPage`. A bare URL is sent to the
 * busiest company's own, replacing its history entry, so Back does not bounce
 * through it.
 *
 * Its own module, as every route's loader is, so a test can mount it under a
 * root of its own.
 */
export async function loadStockTrading({
  context,
  location,
}: {
  context: RouterContext
  location: { search: unknown }
}): Promise<void> {
  const { search, redirect: bare } = await warmTradingPage({ context, location })
  // eslint-disable-next-line @typescript-eslint/only-throw-error
  if (bare) throw redirect({ to: '/market/stock-trading', search, replace: true })
}
